import React, { FC, ReactNode } from "react";
import "./commonFormActionsView.scss";

const CommonFormActionsView: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="common-form-actions-view">{children}</div>;
};

export default CommonFormActionsView;
